import { render, staticRenderFns } from "./CodaBox.vue?vue&type=template&id=de531f7e&scoped=true"
import script from "./CodaBox.vue?vue&type=script&lang=ts"
export * from "./CodaBox.vue?vue&type=script&lang=ts"
import style0 from "./CodaBox.vue?vue&type=style&index=0&id=de531f7e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de531f7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de531f7e')) {
      api.createRecord('de531f7e', component.options)
    } else {
      api.reload('de531f7e', component.options)
    }
    module.hot.accept("./CodaBox.vue?vue&type=template&id=de531f7e&scoped=true", function () {
      api.rerender('de531f7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/plugins/CodaBox.vue"
export default component.exports